import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function listCompetitors(region) {
  const { data } = await client.get('/competitors', {
    params: region ? { region } : undefined,
  });
  return data.competitors;
}

export async function getCompetitorNews(slug, limit = 6) {
  const { data } = await client.get(`/competitors/${encodeURIComponent(slug)}/news`, {
    params: { limit },
  });
  return data;
}

export async function getCompetitorStats(slug) {
  const { data } = await client.get(`/competitors/${encodeURIComponent(slug)}/stats`);
  return data;
}

export async function listScrapeRuns(limit = 20) {
  const { data } = await client.get('/scrape-runs', { params: { limit } });
  return data;
}

export async function listRecentNews({ limit, slug, since } = {}) {
  const params = {};
  if (limit) params.limit = limit;
  if (slug) params.slug = slug;
  if (since) params.since = since;
  const { data } = await client.get('/news/recent', { params });
  return data;
}

const competitorsService = {
  listCompetitors,
  getCompetitorNews,
  getCompetitorStats,
  listScrapeRuns,
  listRecentNews,
};
export default competitorsService;
